import React, { ReactNode } from 'react'
import { useController, useFormContext, useWatch } from 'react-hook-form'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormRadioTileGroup } from '@divvy-web/skylab.form'
import { RADIO_TILE_COLOR_NEUTRAL } from '@divvy-web/skylab.radiotilegroup'
import { RadioTileGroupOption } from '@divvy-web/skylab.radiotilegroup'

import { useWebTracking } from '@sputnik/tracking/WebTrackingContext'

import styles from './styles.module.scss'

interface GoodFitQuestionContentProps {
  question: ReactNode
  options: RadioTileGroupOption[]
  inputName: string
}
const GoodFitQuestionContent = ({ question, options, inputName }: GoodFitQuestionContentProps) => {
  const [getClassName] = useNameFormatter('GoodFitQuestionContent')
  const { control } = useFormContext()
  const {
    field: { value: currentStep, onChange: updateCurrentStep },
  } = useController({ control, name: '__currentStep' })
  const {
    field: { onChange: updateInputValue },
  } = useController({ control, name: inputName })
  const totalStepCount = useWatch({ control, name: '__totalStepCount' })
  const { tracker } = useWebTracking()

  const onChange = (value: string) => {
    if (currentStep !== totalStepCount) {
      updateCurrentStep(currentStep + 1)
    }

    if (inputName === 'annualRevenue')
      tracker?.track('se_signup__qualification_check_revenue__submitted', {
        button_id: `${inputName}-${value}`,
        option_value_selected: value,
      })
    if (inputName === 'currentCash')
      tracker?.track('se_signup__qualification_check_cash_balance__submitted', {
        button_id: `${inputName}-${value}`,
        option_value_selected: value,
      })
    if (inputName === 'creditRange')
      tracker?.track('se_signup__qualification_check_credit_score__submitted', {
        button_id: `${inputName}-${value}`,
        option_value_selected: value,
      })

    updateInputValue(value)
  }

  return (
    <div className={styles[getClassName('')]}>
      <div className={styles[getClassName('question')]}>{question}</div>
      <FormRadioTileGroup
        color={RADIO_TILE_COLOR_NEUTRAL}
        control={control}
        name={inputName}
        options={options}
        onChange={onChange}
      />
    </div>
  )
}

export default GoodFitQuestionContent
